import styles from "./contact-us.module.css";
const contact = "../../assets/images/contact/contact.webp";
const pin = "../../assets/images/contact/pin.png";
const call = "../../assets/images/contact/call.png";
const mail = "../../assets/images/contact/mail.png";
const redrightarrow = "../../assets/images/contact/redrightarrow.png";
// import Link from "next/link";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { createuser } from "../../components/Service/contact";
import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import dynamic from 'next/dynamic';
import Head from "next/head";
const Otpverification = dynamic(() => import("../../components/Modal/Otpverification"));
const Image = dynamic(() => import("next/image"));
const Link = dynamic(() => import("next/link"));

const Contact = () => {
  const [verified, setverified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalOtpstatus, setmodalOtpstatus] = useState(null);
  const [modalOtpExceptionMessage, setmodalOtpExceptionMessage] = useState('');
  const [valuephno, setvaluephno] = useState(undefined);
  const [captchaerror, setcaptchaerror] = useState(undefined);

  function convertJsonStringToNumber(jsonString) {
        // Parse the JSON string to an object
        const jsonObject = JSON.parse(jsonString);
      
        // Iterate over the keys and convert numeric strings to numbers
        for (const key in jsonObject) {
          if (jsonObject.hasOwnProperty(key)
    && !isNaN(jsonObject[key])) {
            jsonObject[key] = Number(jsonObject[key]);
          }
        }
      
        return jsonObject;
  }

  function onChange(value) {
    if (value == null) {
      setverified(false);
    }
    else {

      setverified(true);
    }
  }

   const errorHandlingOnFormSumbit = () => {
     setTimeout(() => {
      if(!document.forms.contactform.checkValidity())
         document.getElementById("formSubmitButton").click();
    },300);
   };

  async function handleOnSubmit(e) {
    e.preventDefault();
    if (verified) {
      const formData = {};
      formData['formType'] = "Contactpage";
      formData['title'] = "Contact page";
      Array.from(e.currentTarget.elements).forEach(field => {
        if (!field.name) return;
        formData[field.name] = field.value;
      });
      //formData['countryCode'] = "+91";
      formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
      formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
      const transform={fields:{...formData}};
      console.log(transform);

      setIsLoading(true);
      createuser(transform)
           .then(response => {
              
               setModalOtp(true);
               setmodalOtpstatus(response.message);
               window.grecaptcha.reset(setverified);
               setverified(false);
               setvaluephno(undefined);
               document.getElementById("contactform").reset();
               setIsLoading(false);
           })
           .catch(error => {
            setModalOtp(true);
            setmodalOtpstatus("failure");
            window.grecaptcha.reset(setverified);
            setverified(false);
            setIsLoading(false);
          })
    }
    else {

      setcaptchaerror(true);
      setTimeout(() => {
        setcaptchaerror(false);
      }, 3000);
    }

  }

     const contactcontent = [
    {
      heading: "Shankar IAS Academy - Head Office",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,  
      address:
        "Door No 18, Old plot No 109,<br/>AL Block, 4th Avenue,<br/>Anna Nagar, Chennai - 600040",
      phones: [
        { label: "", number: "9003190030" }
      ],
      email: "enquiry@shankarias.in",
      url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en",
      url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en"
    },

     { heading: "TNPSC/Banking/SSC Class Building",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,  
      address:
       "TNPSC - Block ( Manasarovar ), No. 255 , AL Block , 4th Avenue, Shanthi colony,<br/>  Anna Nagar,Chennai - 600040",
      phones: [
        { label: "", number: "044-43533445"},
        { label: "", number: "044-45543082"},
        { label: "", number: "7667766266"}
      ],
      email: "enquiry@shankarias.in",
      url: "google.com/maps/place/Shankar+IAS+Academy/@13.0819136,80.2038534,19z/data=!4m6!3m5!1s0x3a526411db99fa8d:0x96a212b8790c0ab2!8m2!3d13.082536!4d80.2051886!16s%2Fg%2F11h7rr2c96?authuser=0&entry=tts&g_ep=EgoyMDI1MDgxOS4wIPu8ASoASAFQAw%3D%3D&skid=90375baa-cf64-4d59-b790-0c8133bcb6da",
      url1: "google.com/maps/place/Shankar+IAS+Academy/@13.0819136,80.2038534,19z/data=!4m6!3m5!1s0x3a526411db99fa8d:0x96a212b8790c0ab2!8m2!3d13.082536!4d80.2051886!16s%2Fg%2F11h7rr2c96?authuser=0&entry=tts&g_ep=EgoyMDI1MDgxOS4wIPu8ASoASAFQAw%3D%3D&skid=90375baa-cf64-4d59-b790-0c8133bcb6da"
     },
    
    {
      heading: "Delhi",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,   
      address:
        "Shop Number 78 First Floor,<br /> Old Rajinder Nagar Market,<br /> Karol Bagh, New Delhi - 110060 <br/> <br/> Landmark: Popular Juice Shop.",
      phones: [
        { label: "", number: "88991 80180" }
      ],
      email: "delhi@shankarias.in",
      //url: "https://maps.app.goo.gl/V3EtvvYvqNjfK1XN9",
      // url1: "https://maps.app.goo.gl/V3EtvvYvqNjfK1XN9"
    },
    {
      heading: "Adyar",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No-2/23, 3rd Cross Street,<br/> Padmanabhanagar, Adyar,<br/> Chennai - 600020",
      phones: [
        { label: "", number: "90252 78278" }
      ],
      email: "adyarsia@shankariasacad.in",
      url: "https://goo.gl/maps/SMh8sACtbCwetN596",
      url1: "https://goo.gl/maps/SMh8sACtbCwetN596"
    },

    {
      heading: "Bengaluru",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No-34, 2nd stage, <br/>Basaveshwara HBCS layout,<br/>Chandra layout bus stand road,<br/> Bengaluru, Karnataka - 560040 <br/> Landmark: Opposite to Karur Vysya Bank",
      phones: [
        { label: "", number: "72593 23266" },
        { label: "", number: "080-23383121" },
        { label: "", number: "81972 92121" }
      ],
      email: "siabengaluru@shankariasacad.in",
      url: "https://goo.gl/maps/CCGtnnwAF772VBwcA",
      url1: "https://goo.gl/maps/CCGtnnwAF772VBwcA"
    },

    {
      heading: "Thiruvananthapuram",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "Suganth Building (Right Side) , Ground Floor, <br> Opposite Kerala State Sisu Kshema Samithi, <br> Thycaud (Gandhi Bhavan Road) , <br> Thiruvananthapuram, Kerala – 695014",
      phones: [
        { label: "", number: "79949 36555" },
        { label: "", number: "75919 02600" },
      ],
      email: "siatrivandrum@shankarias.in",
      // url: "https://goo.gl/maps/id9z1EDWhVfqJUVW9",
      // url1: "https://goo.gl/maps/id9z1EDWhVfqJUVW9"
    },

    {
      heading: "Hyderabad",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "211 & 212, 2nd Floor, B block,<br/> Sri Datta Sai Commercial Complex,<br/> 1-7-1074/B, RTC Cross Roads, In Front of Metro Station Exit A, Opp. Sapthagiri 70mm Theatre, Musheerabad, Hyderabad,<br/> Telangana - 500020",
      phones: [
        { label: "", number: "93902 42708" }
      ],
      email: "hyderabad@shankarias.in",
      // url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Hyderabad/@17.4097882,78.487221,17z/data=!3m1!4b1!4m6!3m5!1s0x8322f8764aad961:0xf0a187bddb107656!8m2!3d17.4097882!4d78.487221!16s%2Fg%2F11kqm5fnmd?entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D",
      // url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Hyderabad/@17.4097882,78.487221,17z/data=!3m1!4b1!4m6!3m5!1s0x8322f8764aad961:0xf0a187bddb107656!8m2!3d17.4097882!4d78.487221!16s%2Fg%2F11kqm5fnmd?entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D"
    },

    {
      heading: "Madurai",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "Plot no:409, B Mall super market, Second floor, church road,Anna Nagar, Sathamangalam, Madurai - 625020 <br/> Landmark: Near Suguna stores bus stop, Second left towards Ambiga College",
      phones: [ 
        { label: "", number: "97896 22555" },
        { label: "", number: "0452-4255455" }
      ],
      email: "maduraisia@shankariasacad.in",
      url: "https://goo.gl/maps/gtj5zwr9tg2saZU97",
      url1: "https://goo.gl/maps/gtj5zwr9tg2saZU97"
    },

    {
      heading: "Salem",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No.207/5 United Arcade, Kauveri Avenue,<br/>State Bank Colony, Junction Main Road,<br/> Salem - 636 004",
      phones: [
        { label: "", number: "0427-2441961" },
        { label: "", number: "89400 80039" }
      ],
      email: "salemsia@shankariasacad.in",
      url: "https://goo.gl/maps/NjfQjqauCjwEGjQaA",
      url1: "https://goo.gl/maps/NjfQjqauCjwEGjQaA"
    },

    {
      heading: "Trichy",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "N.R.Towers, A9 (N), Salai Road, Thillai Nagar,<br/>Trichy - 620 018 <br/> Landmark: LIC -Rock Fort Branch Building",
      phones: [ 
        { label: "", number: "0431-4976911" },
        { label: "", number: "97896 64555" }
      ],
      email: "trichy@shankarias.in",
      url: "https://goo.gl/maps/bom1j7BjxF3pH4827",
      url1:"https://goo.gl/maps/bom1j7BjxF3pH4827"
    },

    {
      heading: "UPSC - Coimbatore",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "Gayathri Building-2nd Floor, Old # 220B, New# 149B, Dr.Rajendraprasad Road <br/> (100 ft Road),Coimbatore - 641012 <br/>Landmark:Above Prince Jewellery ",
      phones: [
        { label: "", number: "98898 98868" },
        { label: "", number: "94892 22761" }
      ],
      email: "siaupsccoimbatore@shankariasacad.in",
      url: "https://maps.app.goo.gl/dP6bGuFeKKxkLAuv8",
      url1: "https://maps.app.goo.gl/dP6bGuFeKKxkLAuv8"
    },

    {
      heading: "TNPSC - Gandhiupuram - Coimbatore",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No.790, 2nd Floor, Cross Cut Road, Gandhipuram (Next to Josco Jewellers), Coimbatore-641 012.",
      phones: [
        { label: "", number: "99945 51898" },
        { label: "", number: "94892 22761" }
      ],
      email: "covai@shankarias.in",
      url: "https://goo.gl/maps/NPMuVydGTEAEZnJP8",
      url1: "https://goo.gl/maps/NPMuVydGTEAEZnJP8"
    },

    {
      heading: "TNPSC - Peelamedu - Coimbatore",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "No.268 A, First Main Road , Anna Nagar ,Peelamedu, Coimbatore - 641004.",
      phones: [
        { label: "", number: "7305951898" },
        { label: "", number: "7845822761" }
      ],
      email: "covai@shankarias.in",
      url: "",
      url1: ""
    },

    {
      heading: "Namakkal",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "Bank of Baroda Backside, Cheran Towers,Block No -2/67, 1st Floor ( West ) , Thillaipuram Main Road, ParamathiRd,Namakkal-637 001.",
      phones: [   
        { label: "", number: "99944 34921" },
        { label: "", number: "04286-223007" }
      ],
      email: "namakkalsia@shankariasacad.in",
      url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Namakkal+-+TNPSC+Coaching+Centre/@11.2183059,78.1630065,17z/data=!4m6!3m5!1s0x3babcfcfd7c57b5d:0x13a7e73738a32d85!8m2!3d11.2183006!4d78.1655814!16s%2Fg%2F11tp4wtm49?entry=tts&g_ep=EgoyMDI1MDQwMi4xIPu8ASoASAFQAw%3D%3D&skid=59c4fdab-784e-4ca1-a3fa-4b7e97754403",
      url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Namakkal+-+TNPSC+Coaching+Centre/@11.2183059,78.1630065,17z/data=!4m6!3m5!1s0x3babcfcfd7c57b5d:0x13a7e73738a32d85!8m2!3d11.2183006!4d78.1655814!16s%2Fg%2F11tp4wtm49?entry=tts&g_ep=EgoyMDI1MDQwMi4xIPu8ASoASAFQAw%3D%3D&skid=59c4fdab-784e-4ca1-a3fa-4b7e97754403"
    },

    {
      heading: "Thiruvarur",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
       "3/310/7 GTN Complex, Mannai salai, (Opp to State Bank of India), Vilamal, Thiruvarur-610 001.",
      phones: [ 
        { label: "", number: "97877 34943" },
        { label: "", number: "70102 62725" }
      ],
      email: "thiruvarur@shankarias.in",
      url: "",
      url1: ""
    },

    {
      heading: "Study Materials Office",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,
      address:
        "AL 19, Flat 110, Shanthi Colony,<br/> [Next to Shankar IAS Academy] <br/>Anna Nagar, Chennai–600 040",
      phones: [ 
        { label: "Anna Nagar", number: "044 45512113" },
        { label: "Anna Nagar", number: "99624 86468" },
        { label: "Adyar", number: "90872 37000" },

      ],
      email: "study@shankarias.in",
      url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai/@13.0800053,80.2011141,17z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en&entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D",
      url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai/@13.0800053,80.2011141,17z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en&entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D"
    },


  ];

  

  const jsonLd = {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      "name": "Contact us | Shankar IAS Academy",
      "url": "https://www.shankariasacademy.com/contact-us/",
      "Image":
      "https://www.shankariasacademy.com/_next/static/media/SIA%20Logo.f7bc4ef0.png",
      "description": "Need help with UPSC preparation? Contact Shankar IAS Academy for expert guidance and support. We're here to assist you along the way.",
      "contactPoint": [
      {
      "@type": "ContactPoint",
      "telephone": "+91-7667766266",
      "contactType": "UPSC, TNPSC Admissions"
      },
      {
      "@type": "ContactPoint",
      "telephone": "044-66024500",
      "contactType": "UPSC, TNPSC Admissions"
      },
      {
      "@type": "ContactPoint",
      "telephone": "044-43533445",
      "contactType": "UPSC, TNPSC Admissions"
      },
      {
      "@type": "ContactPoint",
      "telephone": "044-45543082",
      "contactType": "UPSC, TNPSC Admissions"
      },
      
      ]
}

  return (
    <>

      {isLoading &&
        <div className="APIPreLoader" id="APIPreLoader">
          <div className="loader">Loading...</div>
        </div>
      }
      <Head>
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="robots" content="noodp,noydir" />
          <meta name="robots" content="index,follow" />
          <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
          <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
          <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
          <title>Contact us | Shankar IAS Academy</title>
          <meta name="title" content="Contact us | Shankar IAS Academy" />
          <meta name="description" content="Need help with UPSC preparation? Contact Shankar IAS Academy for expert guidance and support. We're here to assist you along the way." />
          <link rel="canonical" href="https://www.shankariasacademy.com/contact-us/" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Contact us | Shankar IAS Academy" />
          <meta property="og:description" content="Need help with UPSC preparation? Contact Shankar IAS Academy for expert guidance and support. We're here to assist you along the way." />
          <meta property="og:url" content="https://www.shankariasacademy.com/contact-us/" />
          <meta property="og:site_name" content="Shankar IAS Academy" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@shankarias" />
      </Head>

      <Otpverification show={modalOtp} title={modalOtpstatus} frompage="Contactpage" onHide={() => setModalOtp(false)} />
      <Navbar title="contact" />

      <div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-5">
            <h1 className={`${styles.pagemaintitle}`}>Contact</h1>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col pt-3 pt-md-5 text-center imgboxbelow">
            <Image src={contact} className="img-fluid" width={1447} height={438} alt="contact-us banner" title="Contact" />
          </div>
        </div>
      </div>

      <div className="container-fluid" style={{ background: '#F4F6F8 0% 0% no-repeat padding-box' }}>
        <div className="row">
          <div className="col py-5 px-0">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h2 className={`${styles.sectiontitle}`}>Our Branches</h2>
                </div>
              </div>
            </div>

            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="row">
                    {contactcontent.map((item, index) => (
                    <div className="col-md-6 col-lg-6 col-xl-4 col-12 mb-3">
                      <div className={`${styles.contactbox} h-100`}>
                        <div className={`${styles.contactboxheight} px-4 pt-4 pt-md-5`}>

                              {/* Heading */}
                              <div className={`${styles.acheivername2} mb-3`}>
                                {item.heading}
                              </div>

                              {/* Address */}
                              <div className="row">
                                <div className="col-1 pe-0">
                                  <Image src={item.Image} width={14} height={14} alt="location" />
                                </div>
                                <div className="col-11">
                                  {item.address && (
                                    <div
                                      className={styles.acheiverrank}
                                      dangerouslySetInnerHTML={{ __html: item.address }}
                                    />
                                  )}
                                  {item.address1 && (
                                    <div className={styles.acheiverrank}>
                                      {item.address1}
                                    </div>
                                  )}
                                  {item.address2 && (
                                    <div className={styles.contactsubcontent}>
                                      {item.address2}
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Phone Numbers */}
                              {item.phones?.length > 0 && (
                                <div className="row mt-2">
                                  <div className="col-1 pe-0 d-flex align-items-start">
                                    <Image
                                      src={item.Image1}
                                      width={16}
                                      height={16}
                                      alt="phone"
                                    />
                                  </div>

                                  <div className="col-11">
                                    {item.phones?.map((phone, index) => (
                                      <div key={index} className="mb-1">
                                        <a
                                          href={`tel:${phone.number.replace(/[^0-9]/g, "")}`}
                                          className={styles.mobilemaillinks}
                                        >
                                          {phone.number}
                                        </a>
                                      </div>
                                    ))}
                                  </div>
                                </div>

                              )}

                              {/* Email */}
                              {item.email && (
                                <div className="row mt-2">
                                  <div className="col-1 pe-0">
                                    <Image src={item.Image2} width={14} height={14} alt="email" />
                                  </div>
                                  <div className="col-11">
                                    <p className={styles.acheiverrank}>
                                      <a
                                        href={`mailto:${item.email}`}
                                        className={styles.mobilemaillinks}
                                      >
                                        {item.email}
                                      </a>
                                    </p>
                                  </div>
                                </div>
                              )}
                        </div>

                        {/* ===== Direction + Arrow Section ===== */}
                        {(item.url || item.url1) && (
                          <>
                            <hr className="mb-0" />
                            <div className="px-4 pb-1 py-md-2">
                              <div className="row align-items-center">                                 
                                <div className="col-9 col-xl-10">
                                  {item.url && (
                                        <Link
                                          href={item.url}
                                          target="_blank"
                                          className={styles.redunderline}
                                        >
                                          {item.direction || "Get Directions"}
                                        </Link>
                                  )}
                                </div>
                                <div className="col-3 col-xl-2 text-end">
                                  {item.url1 && item.Image3 && (
                                        <Link href={item.url1} target="_blank">
                                          <Image
                                            src={item.Image3}
                                            width={30}
                                            height={30}
                                            className={`${styles.img} img-fluid`}
                                            alt="arrow"
                                          />
                                        </Link>
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-8 col-lg-5 col-12 mx-auto pt-md-5 pt-4">
            <p className={`${styles.acheiverrank} text-center mb-0`}>For any queries, you can write to us.</p>
            <p className={`${styles.acheiverrank} text-center`}>We will get in touch with you shortly.</p>
          </div>
        </div>

        <div className="row">
          <div className="col-md-7 col-lg-4 col-12 mx-auto">
            <form onSubmit={handleOnSubmit} id="contactform" name="contactform" autoComplete="off">
              <div className="row pt-5">
                <div className="col-12">
                  <div className="mb-4">
                    <p className="text-start mb-0"><label htmlFor="exampleInputName " className={`${styles.acheiverrank} form-label`}>Name<span className="formstar">*</span></label></p>
                    <input type="text" className={`${styles.acheiverrank} form-control`} autoComplete="off" pattern="[A-Za-z]{3,}" name="name" minLength="1" required />
                  </div>
                </div>

                <div className="col-12">
                  <div className="mb-4">
                    <p className="text-start mb-0"><label htmlFor="exampleInputmail" className={`${styles.acheiverrank} form-label`}>Email Address<span className="formstar">*</span></label></p>
                    <input type="email" className={`${styles.acheiverrank} form-control`} autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                  </div>
                </div>

                <div className="col-12">
                  <div className="mb-4">
                    <p className="text-start mb-0"><label htmlFor="exampleInputPhno" className={`${styles.acheiverrank} form-label`}>Phone No<span className="formstar">*</span></label></p>
                    <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" pattern="[0-9]{10}" maxlength="10" required />
                  </div>
                </div>

                <div className="col-12">
                  <div className="mb-4">
                    <p className="text-start mb-0"><label htmlFor="exampleInputdep" className={`${styles.acheiverrank} form-label`}>Department<span className="formstar">*</span></label></p>
                    <select className={`${styles.acheiverrank} form-select form-control`} id="autoSizingSelect" name="department" autoComplete="off" placeholder="Years of Experience" required>
                      <option value="" disabled selected hidden>--Select--</option>
                      <option value="TNPSC">TNPSC</option>
                      <option value="UPSC">UPSC</option>
                      <option value="BANKING">BANKING</option>
                    </select>
                  </div>
                </div>


                <div className="col-12">
                  <div className="mb-4">
                    <p className="text-start mb-0"><label htmlFor="exampleInputMessage*" className={`${styles.acheiverrank} form-label`}>Message (optional)</label></p>
                    <textarea type="textarea" className={`${styles.acheiverrank} form-control`} autoComplete="off" minLength="10" name="query" style={{ height: "87px" }} ></textarea>
                  </div>
                </div>

                <div className="col-12  pb-3 mx-auto text-center">
                  <ReCAPTCHA className={`${styles.captcha}`}
                    sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                    onChange={onChange}
                  />
                </div>
                <div className="">
                  {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                </div>

                <div className="col-12 mb-4">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" value="" id={styles.invalidCheck2} />
                    <label className={`${styles.checkboxcontent} form-check-label`} htmlFor="invalidCheck2">
                      I would like to receive updates from Shankar IAS Academy
                    </label>
                  </div>
                </div>
                
                <p className="text-center"><button className={`${styles.normalbutton}`} type="submit" onClick={errorHandlingOnFormSumbit}>Send</button></p>
                <button className="d-none" type="submit" id="formSubmitButton">Send</button>

              </div>

            </form>

          </div>
        </div>

      </div>

      <Footer />

    </>
  )
}

export default Contact